<template>
    <component :is="componentType" :disabled="isNavigating || undefined" @click="handleClick">
        <slot></slot>
    </component>
</template>

<script setup>
import { Link } from "@inertiajs/vue3";
import { isInIFrame, openUrl } from "~vue/utils";
import { logError } from "~vue/utils/logUtils";
import { ref, useAttrs } from "vue";

const props = defineProps({
    // Async work (e.g. an analytics event) that must finish before a full-page navigation unloads it.
    // Only awaited in an iFrame (MS Teams); an Inertia visit keeps the page alive, so it is not awaited there.
    before: { type: Function, default: undefined },
});

const attrs = useAttrs();
const isNavigating = ref(false);

// Returns the Inertia Link component unless we're in an iFrame (MS Teams) or the method is not GET
const getComponentType = () => {
    if (!isInIFrame() || (attrs.method && attrs.method.toLowerCase() !== "get")) {
        return Link;
    }
    return "button";
};

const componentType = getComponentType();

const handleClick = async () => {
    if (componentType === Link) {
        props.before?.();
        if (!attrs.href) {
            // log an error for missing href prop for now, and use this to fallback to the openUrl util
            // in the future typescript will catch prop related issues
            logError("BaseLink.vue: 'href' attribute is required for Inertia Link.");
            openUrl(attrs.href, { queryParams: attrs.data });
        }
    } else {
        isNavigating.value = true;
        await props.before?.();
        openUrl(attrs.href, { queryParams: attrs.data });
    }
};
</script>
